// extracted by mini-css-extract-plugin
export default {"window":"yourAdress_window__mHL55","caption":"yourAdress_caption__BwnnE"};